angular.module('st').controller('UptimeMetricsController', UptimeMetricsController);
//angular.module('st').push('ngAnimate');
UptimeMetricsController.$inject = ['$scope', '$rootScope', '$sce', '$filter', '$http', '$q', '$timeout', '$interval'];

function UptimeMetricsController($scope, $rootScope, $sce, $filter, $http, $q, $timeout, $interval) {
    var umc = this;

    // --- Constants ---
    const REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes in milliseconds
    // Update the constants
    umc.PING_THRESHOLDS = {
        good: 800,
        okay: 1500,
        bad: 3000,
        veryBad: Number.MAX_VALUE
    };
    umc.HEALTH_THRESHOLDS = { low: 99, medium: 98, high: 95 };
    umc.COLORS = {
        good: 'limegreen',
        okay: '#9bff00',  // A color between green and gold
        bad: '#FFD700',   // Original gold color
        veryBad: '#ff4500', // Original red color
        none: 'lightgray'
    };
    // --- Lookup Data ---
    //umc.VISTA_ENDPOINTS_KEY = [
    //    { "name": "Login", "endpoint": "RESTLoyalty.svc/member/validate", "chartid": "login" },
    //    { "name": "Gift Cards", "endpoint": "RESTData.svc/gift-cards/balance/90010069597767027132", "chartid": "giftcard" },
    //    { "name": "Cinemas", "endpoint": "OData.svc/Cinemas", "chartid": "cinemas" },
    //    { "name": "MFO Toggle", "endpoint": "https://api.celemonitor.com/api/mfoStatus", "chartid": "mfotoggle" }
    //];
    umc.VISTA_ENDPOINTS_KEY = [
        //Misc
        {
            "name": "MFO Toggle",
            "endpoint": "https://api.celemonitor.com/api/mfoStatus",
            "chartid": "mfotoggle",
            "server": "DMZ-DENETHOR",
            "description": "Toggle for MFO on Celemonitor - alters mfo status on on CO-GIMLI",
            "tags": ["mfo toggle"]
        },
        // Central Servers
        {
            "name": "Gift Cards",
            "endpoint": "RESTData.svc/gift-cards/balance/90010069597767027132",
            "chartid": "giftcard",
            "description": "Gift Cards & Vouchers Server - Handles balance checks on gift cards, validates vouchers",
            "server": "CO-MERRY",
            "tags": ["gift-cards", "vouchers"]
        },
        {
            "name": "Login",
            "endpoint": "RESTLoyalty.svc/member/validate",
            "chartid": "login",
            "description": "Loyalty Server - Handles loyalty point balances, loyalty logins, recognition rewards, loyalty tiers",
            "server": "CO-FRODO",
            "tags": ["loyalty", "points", "rewards"]
        },
        {
            "name": "CO-GS01",
            "endpoint": "OData.svc/giftstore",
            "chartid": "giftstore",
            "description": "Gift Store - Handles purchase/renewal of VIP subscription, purchase of gift cards & gold tickets",
            "server": "CO-GS01",
            "tags": ["vip", "subscriptions", "gift-cards"]
        },
        {
            "name": "CO-GIMLI",
            "endpoint": "payment-access-tokens/Braintree",
            "chartid": "braintree",
            "description": "Connect Server - Braintree tokens, relays info between cinema servers & website",
            "server": "CO-GIMLI",
            "tags": ["payments", "braintree"]
        },
        {
            "name": "Cinemas",
            "endpoint": "OData.svc/Cinemas",
            "chartid": "cinemas",
            "description": "API Host Server",
            "server": "DMZ-LEGOLAS",
            "tags": ["api"]
        },
        // Cinema Servers
        {
            "name": "AR-DB01",
            "endpoint": "orders?cinemaId=009",
            "chartid": "carousel",
            "description": "Cinema Carousel",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "BH-DB01",
            "endpoint": "orders?cinemaId=007",
            "chartid": "benton",
            "description": "Celebration Benton Harbor",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "CR-DB01",
            "endpoint": "orders?cinemaId=003",
            "chartid": "crossroads",
            "description": "Celebration Crossroads",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "GD-DB01",
            "endpoint": "orders?cinemaId=011",
            "chartid": "getty",
            "description": "Getty Drive-in",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "GN-DB01",
            "endpoint": "orders?cinemaId=002",
            "chartid": "grnorth",
            "description": "Celebration GR North",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "GS-DB01",
            "endpoint": "orders?cinemaId=004",
            "chartid": "grsouth",
            "description": "Celebration GR South",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "LA-DB01",
            "endpoint": "orders?cinemaId=006",
            "chartid": "lansing",
            "description": "Celebration Lansing",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "MP-DB01",
            "endpoint": "orders?cinemaId=008",
            "chartid": "mtpleasant",
            "description": "Celebration Mt Pleasant",
            "tags": ["cinema", "bookings", "concessions"]
        },
        // MM-DB01: Meridian Mall closed 2026-10-05, no longer pinged (UptimeLogger.ACTIVE_CINEMA_IDS).
        // Kept so existing rows still get a label until they age out of the 30-day window.
        {
            "name": "MM-DB01",
            "endpoint": "orders?cinemaId=012",
            "chartid": "meridian",
            "description": "Studio C Meridian Mall",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "RT-DB01",
            "endpoint": "orders?cinemaId=005",
            "chartid": "rivertown",
            "description": "Celebration Rivertown",
            "tags": ["cinema", "bookings", "concessions"]
        },
        {
            "name": "SP-DB01",
            "endpoint": "orders?cinemaId=013",
            "chartid": "studiopark",
            "description": "Celebration Studio Park",
            "tags": ["cinema", "bookings", "concessions"]
        }
    ];
    const BT_URL_KEYWORD_OLD = "/payment-access-tokens/Braintree";
    const BT_URL_KEYWORD = "payment-access-tokens/Braintree";
    const ORDERS_URL_KEYWORD = "orders?cinemaId";
    const SEATPLAN_URL_KEYWORD = "/screens/01/seat-plan";
    const SESSION_SEATPLAN_URL_KEYWORD = '/sessions/'; 

    const DAYS = 30;
    const CHARTS = {};

    // --- Data ---
    umc.btLast30Days = [];
    umc.nonBtLast30Days = [];
    umc.orderLast30Days = [];
    umc.seatPlanLast30Days = [];
    umc.metrics = [];
    umc.summaryCards = [];
    umc.ping24Hours = null;
    umc.ping24HoursBT = null;
    umc.ping24HoursOrders = null;
    umc.ping24HoursSeatPlans = null;
    umc.last30DaysAllUniqueUnhealthyDetails = [];
    umc.isLoadingHistory = true;
    umc.selectedDate = null;
    umc.selectedEndpoint = null;
    umc.customSearchResults = null;
    umc.customModalSearching = false;
    // Add new properties
    umc.customStartDate = null;
    umc.customEndDate = null;
    umc.customEndpoint = null;
    umc.customRangeData = null;

    // --- Initialization ---
    umc.init = function () {
        startAutoRefresh();
    };

// Add this after your init function
function startAutoRefresh() {
    // Initial load
    dashBoardCharts();
    
    // Set up interval for refresh
    const intervalPromise = $interval(function() {
        umc.get24HourPings();
        umc.getBraintreeDailyHealthLast30Days();
        umc.getNonBraintreeDailyHealthLast30Days();
        umc.getOrdersDailyHealthLast30Days();
        umc.getSeatPlansDailyHealthLast30Days();
        umc.getSessionSeatPlansDailyHealthLast30Days();
    }, REFRESH_INTERVAL);

    // Clean up interval when scope is destroyed
    $scope.$on('$destroy', function() {
        if (intervalPromise) {
            $interval.cancel(intervalPromise);
        }
    });
}

function dashBoardCharts() {
    umc.get24HourPings();
    umc.getBraintreeDailyHealthLast30Days();
    umc.getNonBraintreeDailyHealthLast30Days();
    umc.getOrdersDailyHealthLast30Days();
    umc.getSeatPlansDailyHealthLast30Days();
    umc.getSessionSeatPlansDailyHealthLast30Days();
}

    // --- Helpers ---
    function createLast30DaysArray() {
        const daysArray = [];
        for (let i = DAYS - 1; i >= 0; i--) {
            const date = new Date();
            date.setDate(date.getDate() - i);
            date.setHours(0, 0, 0, 0);
            daysArray.push({
                date: date,
                item: { }
            });
        }
        return daysArray;
    }
    function getResponseTimeByDateAndEndpoint(date, endpointUrl) {
        var config = {
            params: {
                date: date.toISOString(),
                endpointUrl: endpointUrl
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/uptime/getResponseTimeByDateAndEndpoint", config)
            .then(deferred.resolve);
        return deferred.promise;
    }

    function isGettySeasonallyClosed() {
    const now = new Date();
    const month = now.getMonth() + 1; // 1-12
    // Getty closed Oct-Apr (months 10, 11, 12, 1, 2, 3, 4)
    return month >= 10 || month <= 4;
}

    function buildAllUniqueUnhealthyDetailsArray() {

        const shouldExcludeGetty = isGettySeasonallyClosed();

        function getDateKey(date) {
            try {
                return date.toISOString().slice(0, 10);
            } catch (err) {
                console.error(date, err);
            }
        }

        const allDays = {};
        [umc.btLast30Days, umc.nonBtLast30Days, umc.orderLast30Days, umc.seatPlanLast30Days].forEach((arr, index) => {
            arr.forEach(dayObj => {
                const key = getDateKey(dayObj.date);
                if (!allDays[key]) {
                    allDays[key] = {
                        date: dayObj.date,
                        details: [],
                        healthyPercentages: [],
                    };
                }
            });
        });

        // Add unique details from all arrays with category information
        const sources = [
            { array: umc.btLast30Days, category: 'Braintree Payment Tokens' },
            { array: umc.nonBtLast30Days, category: 'Other Services' },
            { array: umc.orderLast30Days, category: 'Orders' },
            { array: umc.seatPlanLast30Days, category: 'Seat Plans' },
            { array: umc.sessionSeatPlanLast30Days, category: 'Session Seat Plans' }
        ];

            sources.forEach(source => {
        source.array.forEach(dayObj => {
            const key = getDateKey(dayObj.date);
            
            // ✅ NEW: Skip Getty-related errors when seasonally closed
            if (shouldExcludeGetty && dayObj.item.UnhealthyDetails) {
                const filteredDetails = dayObj.item.UnhealthyDetails
                    .split(' | ')
                    .filter(msg => !msg.includes('011') && !msg.includes('Getty'))
                    .join(' | ');
                
                if (!filteredDetails) {
                    return; // Skip this day if all errors were Getty-related
                }
                dayObj.item.UnhealthyDetails = filteredDetails;
            }
                if (dayObj.item.HealthyPercentage) {
                    allDays[key].healthyPercentages.push(dayObj.item.HealthyPercentage);
                }
                if (dayObj.item && dayObj.item.UnhealthyDetails) {
                    dayObj.item.UnhealthyDetails.split(' | ').forEach(msg => {
                        msg = msg.trim();
                        if (msg) {
                            // Create an object containing both message and category
                            const detail = {
                                message: msg,
                                category: source.category,
                                endpoint: dayObj.item.EndpointUrl // Include endpoint URL if available
                            };
                            // Check if this exact message+category combination already exists
                            const exists = allDays[key].details.some(d =>
                                d.message === detail.message &&
                                d.category === detail.category
                            );
                            if (!exists) {
                                allDays[key].details.push(detail);
                            }
                        }
                    });
                }
            });
        });

        Object.values(allDays).forEach(day => {
            day['labeldate'] = formatDayLabel(day.date);
        });

        umc.last30DaysAllUniqueUnhealthyDetails = Object.values(allDays)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
        umc.isLoadingHistory = false;

        buildSummaryCards();
    }

    function findGlobalMaxPing() {
        let maxPing = 0;

        // Check all data sources
        [umc.ping24Hours, umc.ping24HoursBT, umc.ping24HoursOrders, umc.ping24HoursSeatPlans].forEach(dataGroup => {
            if (!dataGroup) return;

            Object.values(dataGroup).forEach(pingSet => {
                const maxInSet = Math.max(...pingSet.map(obj => obj.AverageResponseTimeMs));
                maxPing = Math.max(maxPing, maxInSet);
            });
        });

        // Round up to nearest 500
        return Math.ceil(maxPing / 500) * 500;
    }

    // Call this after both AJAX calls complete
function tryBuildAllUniqueUnhealthyDetailsArray() {
    if (umc.btLast30Days && umc.btLast30Days.length &&
        umc.nonBtLast30Days && umc.nonBtLast30Days.length &&
        umc.orderLast30Days && umc.orderLast30Days.length &&
        umc.seatPlanLast30Days && umc.seatPlanLast30Days.length &&
        umc.sessionSeatPlanLast30Days && umc.sessionSeatPlanLast30Days.length) {
        buildAllUniqueUnhealthyDetailsArray();
    }
}

    // --- Summary Cards ---
    function buildSummaryCards() {
        var categories = [
            { key: 'braintree',        label: 'Braintree',      daysArray: umc.btLast30Days,            pingGroups: umc.ping24HoursBT,             chartId: 'summary-chart-braintree' },
            { key: 'orders',           label: 'Orders',          daysArray: umc.orderLast30Days,         pingGroups: umc.ping24HoursOrders,         chartId: 'summary-chart-orders' },
            { key: 'seatplans',        label: 'Seat Plans',      daysArray: umc.seatPlanLast30Days,      pingGroups: umc.ping24HoursSeatPlans,      chartId: 'summary-chart-seatplans' },
            { key: 'sessionseatplans', label: 'Session Plans',   daysArray: umc.sessionSeatPlanLast30Days, pingGroups: umc.ping24HoursSessionSeatPlans, chartId: 'summary-chart-sessionseatplans' },
            { key: 'other',            label: 'Central Svcs',   daysArray: umc.nonBtLast30Days,         pingGroups: umc.ping24Hours,               chartId: 'summary-chart-other' }
        ];

        umc.summaryCards = categories.map(function(cat) {
            var daysArray = cat.daysArray || [];
            var pingGroups = cat.pingGroups;

            // Today's health %
            var todayHealth = null;
            if (daysArray.length) {
                var todayItem = daysArray[daysArray.length - 1];
                if (todayItem.item && todayItem.item.HealthyPercentage != null) {
                    todayHealth = Math.floor(todayItem.item.HealthyPercentage);
                }
            }

            // Average ms from last 2 hourly readings across all endpoints in category
            var recentMs = null;
            if (pingGroups) {
                var allRecent = [];
                Object.values(pingGroups).forEach(function(arr) {
                    if (arr && arr.length) {
                        arr.slice(-2).forEach(function(p) {
                            if (p.AverageResponseTimeMs > 0) allRecent.push(p.AverageResponseTimeMs);
                        });
                    }
                });
                if (allRecent.length) {
                    recentMs = Math.round(allRecent.reduce(function(a, b) { return a + b; }, 0) / allRecent.length);
                }
            }

            // Most recent day with any alert (scan backward through 30-day data)
            var mostRecentAlertDate = null;
            for (var i = daysArray.length - 1; i >= 0; i--) {
                if (daysArray[i].item && daysArray[i].item.UnhealthyDetails) {
                    mostRecentAlertDate = daysArray[i].date;
                    break;
                }
            }

            // Status class (mirrors getDayColor logic for a single category's health %)
            var statusClass = 'none';
            var statusLabel = '—';
            if (todayHealth != null) {
                if (todayHealth <= umc.HEALTH_THRESHOLDS.high)   { statusClass = 'veryBad'; statusLabel = 'Critical'; }
                else if (todayHealth <= umc.HEALTH_THRESHOLDS.medium) { statusClass = 'bad';  statusLabel = 'Degraded'; }
                else { statusClass = todayHealth < 100 ? 'okay' : 'good'; statusLabel = 'Healthy'; }
            }

            return {
                key:                  cat.key,
                label:                cat.label,
                todayHealth:          todayHealth,
                recentMs:             recentMs,
                mostRecentAlertDate:  mostRecentAlertDate,
                statusClass:          statusClass,
                statusLabel:          statusLabel,
                chartId:              cat.chartId,
                daysArray:            daysArray
            };
        });

        // Render mini charts once Angular has stamped the repeated DOM
        $timeout(function() {
            umc.summaryCards.forEach(function(card) {
                if (card.daysArray && card.daysArray.length) {
                    renderSummaryChart(card.chartId, card.daysArray);
                }
            });
        }, 200);
    }

    function renderSummaryChart(elementId, fullDaysArray) {
        // Use last 10 days only
        var daysArray = fullDaysArray.slice(-10);
        var ctx = document.getElementById(elementId);
        if (!ctx) return;

        var healthPercentage = daysArray.map(function(obj) {
            return (obj.item && obj.item.HealthyPercentage != null) ? Math.floor(obj.item.HealthyPercentage) : undefined;
        });
        var backgroundColors = healthPercentage.map(function(value) {
            if (value == undefined) return umc.COLORS.none;
            if (value <= umc.HEALTH_THRESHOLDS.high)   return umc.COLORS.veryBad;
            if (value <= umc.HEALTH_THRESHOLDS.medium)  return umc.COLORS.bad;
            if (value < 100)                             return umc.COLORS.okay;
            return umc.COLORS.good;
        });
        var labels = daysArray.map(function(obj) { return formatDayLabel(obj.date); });

        var data = {
            labels: labels,
            datasets: [{
                data: new Array(daysArray.length).fill(1),
                backgroundColor: backgroundColors,
                borderColor: backgroundColors,
                borderRadius: 2,
                borderSkipped: false
            }]
        };

        var config = {
            type: 'bar',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                                var hp = healthPercentage[context.dataIndex];
                                return hp != null ? hp + '% uptime' : 'no data';
                            }
                        }
                    }
                },
                scales: {
                    x: { grid: { display: false }, ticks: { display: false }, border: { display: false } },
                    y: { min: 0, max: 1, grid: { display: false }, ticks: { display: false }, border: { display: false } }
                },
                layout: { padding: { left: 2, right: 2, top: 2, bottom: 2 } },
                onHover: function(event, elements) {
                    event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
                },
                onClick: function(event, elements) {
                    if (!elements || elements.length === 0) return;
                    var clickedDate = daysArray[elements[0].index].date;
                    $timeout(function() {
                        umc.customStartDate = new Date(clickedDate);
                        umc.customEndDate = new Date(clickedDate);
                        umc.getCustomRangeData();
                        var el = document.querySelector('.custom-range-lookup');
                        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    });
                }
            }
        };

        // Always destroy and recreate — the canvas may have been replaced by ng-repeat
        if (CHARTS[elementId]) {
            try { CHARTS[elementId].destroy(); } catch(e) {}
            delete CHARTS[elementId];
        }
        CHARTS[elementId] = new Chart(ctx, config);
    }

    function matchAndPopulateDays(daysArray, responseData) {
        daysArray.forEach(function (dayObj) {
            var match = responseData.find(function (dataObj) {
                var dayDate = dayObj.date;
                // The Day value from the server is a UTC date (e.g. /Date(1743465600000)/).
                // Parse the UTC milliseconds and compare using UTC getters so that
                // e.g. UTC midnight 2026-04-01 matches the April 1 bucket, not March 31.
                var utcMs = parseInt(dataObj.Day.match(/\d+/)[0], 10);
                var dataDateUTC = new Date(utcMs);
                return dayDate.getFullYear() === dataDateUTC.getUTCFullYear() &&
                    dayDate.getMonth() === dataDateUTC.getUTCMonth() &&
                    dayDate.getDate() === dataDateUTC.getUTCDate();
            });
            if (match) {
                dayObj.item.checked = match.checked !== undefined ? match.checked : dayObj.item.checked;
                dayObj.item.healthy = match.healthy !== undefined ? match.healthy : dayObj.item.healthy;
                dayObj.item.HealthyPercentage = match.HealthyPercentage !== undefined ? match.HealthyPercentage : dayObj.item.HealthyPercentage;
                dayObj.item.AverageResponseTimeMs = match.AverageResponseTimeMs !== undefined ? match.AverageResponseTimeMs : dayObj.item.AverageResponseTimeMs;
                dayObj.item.UnhealthyDetails = match.UnhealthyDetails !== undefined ? match.UnhealthyDetails : dayObj.item.UnhealthyDetails;
                dayObj.data = true;
            } else {
                dayObj.data = false;
            }
        });
    }

function jsonDateToJSDate(datestr) {
    const milliseconds = parseInt(datestr.match(/\d+/)[0], 10);
    
    // ✅ SIMPLEST FIX: Database stores UTC, but everyone is in EST
    // Convert UTC to EST by subtracting 5 hours (or 4 for EDT)
    const utcDate = new Date(milliseconds);
    
    // Determine if DST is in effect (March-November roughly)
    const month = utcDate.getUTCMonth() + 1; // 1-12
    const isDST = month >= 3 && month <= 10; // Approximate DST period
    
    // EST offset: -5 hours, EDT offset: -4 hours
    const offsetHours = isDST ? -4 : -5;
    const estMilliseconds = milliseconds + (offsetHours * 60 * 60 * 1000);
    
    // Return as local date (which will be interpreted correctly in EST timezone)
    return new Date(estMilliseconds);
}

    function formatDayLabel(date) {
        const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
        const day = date.getDate();
        const ordinal = day + (day % 10 == 1 && day != 11 ? 'st' :
            day % 10 == 2 && day != 12 ? 'nd' :
                day % 10 == 3 && day != 13 ? 'rd' : 'th');
        return months[date.getMonth()] + ' ' + ordinal;
    }

    // --- API Calls ---
    function getSessionSeatPlansDailyHealthLast30Days() {
        $http.get("/rpc/uptime/getSessionSeatPlansDailyHealthLast30DaysAsync").then(function (response) {
            umc.sessionSeatPlanLast30Days = createLast30DaysArray();
            if (response && response.data) {
                matchAndPopulateDays(umc.sessionSeatPlanLast30Days, response.data);
            }
            $timeout(function () {
                umc.isLoading30.sessionSeatplans = false;
                render30DaysChart('sessionseatplan30days', umc.sessionSeatPlanLast30Days);
                tryBuildAllUniqueUnhealthyDetailsArray();
            }, 1000);
        });
    }

    function getBraintreeDailyHealthLast30Days() {
        $http.get("/rpc/uptime/getBraintreeDailyHealthLast30DaysAsync").then(function (response) {
            umc.btLast30Days = createLast30DaysArray();
            if (response && response.data) {
                matchAndPopulateDays(umc.btLast30Days, response.data);
            }
            $timeout(function () {
                umc.isLoading30.braintree = false;
                render30DaysChart('bt30days', umc.btLast30Days);
                tryBuildAllUniqueUnhealthyDetailsArray();
            }, 1000);
        });
    }
    function getNonBraintreeDailyHealthLast30Days() {
        $http.get("/rpc/uptime/getNonBraintreeDailyHealthLast30DaysAsync").then(function (response) {
            umc.nonBtLast30Days = createLast30DaysArray();
            if (response && response.data) {
                matchAndPopulateDays(umc.nonBtLast30Days, response.data);
            }
            $timeout(function () {
                umc.isLoading30.nonBraintree = false;
                render30DaysChart('vista30days', umc.nonBtLast30Days);
                tryBuildAllUniqueUnhealthyDetailsArray();
            }, 1000);
        });
    }
    // Add new API functions
function getOrdersDailyHealthLast30Days() {
    $http.get("/rpc/uptime/getOrdersDailyHealthLast30DaysAsync").then(function (response) {
        umc.orderLast30Days = createLast30DaysArray();
        if (response && response.data) {
            matchAndPopulateDays(umc.orderLast30Days, response.data);
        }
        $timeout(function () {
            umc.isLoading30.orders = false;
            render30DaysChart('orders30days', umc.orderLast30Days);
            tryBuildAllUniqueUnhealthyDetailsArray();
        }, 1000);
    });
}

function getSeatPlansDailyHealthLast30Days() {
    $http.get("/rpc/uptime/getSeatPlansDailyHealthLast30DaysAsync").then(function (response) {
        umc.seatPlanLast30Days = createLast30DaysArray();
        if (response && response.data) {
            matchAndPopulateDays(umc.seatPlanLast30Days, response.data);
        }
        $timeout(function () {
            umc.isLoading30.seatplans = false;
            render30DaysChart('seatplan30days', umc.seatPlanLast30Days);
            tryBuildAllUniqueUnhealthyDetailsArray();
        }, 1000);
    });
}

    //temp function to be removed later
function normalizeBTUrls(data) {
    return data.map(item => {
        // Create a new object to avoid modifying the original
        let normalizedItem = { ...item };
        
        // Check if URL starts with / and contains BT_URL_KEYWORD or BT_URL_KEYWORD_OLD
        if (normalizedItem.EndpointUrl.startsWith('/') && 
            (normalizedItem.EndpointUrl.includes(BT_URL_KEYWORD) || 
             normalizedItem.EndpointUrl.includes(BT_URL_KEYWORD_OLD))) {
            // Remove leading slash
            normalizedItem.EndpointUrl = normalizedItem.EndpointUrl.substring(1);
        }
        return normalizedItem;
    });
}
    function get24HourPings() {
        $http.get("/rpc/uptime/averageResponseTime24Hours").then(function (response) {
                if (response && response.data) {
            const filteredDataBT = response.data.filter(obj => obj.EndpointUrl.includes(BT_URL_KEYWORD) || obj.EndpointUrl.includes(BT_URL_KEYWORD_OLD));
            const filteredDataOrders = response.data.filter(obj => obj.EndpointUrl.includes(ORDERS_URL_KEYWORD));
                    const filteredDataSeatPlans = response.data.filter(obj => obj.EndpointUrl.includes(SEATPLAN_URL_KEYWORD));
                    const filteredDataSessionSeatPlans = response.data.filter(obj =>
                        obj.EndpointUrl.includes(SESSION_SEATPLAN_URL_KEYWORD) &&
                        obj.EndpointUrl.includes('seat-plan')
                    );
            const filteredDataOther = response.data.filter(obj => 
                !obj.EndpointUrl.includes(BT_URL_KEYWORD) &&
                !obj.EndpointUrl.includes(BT_URL_KEYWORD_OLD) &&
                !obj.EndpointUrl.includes(ORDERS_URL_KEYWORD) &&
                !obj.EndpointUrl.includes(SEATPLAN_URL_KEYWORD) &&
                !(obj.EndpointUrl.includes(SESSION_SEATPLAN_URL_KEYWORD) &&
                    obj.EndpointUrl.includes('seat-plan'))
            );

            //old BT fix
            
            
                        // Normalize BT URLs before grouping
            const normalizedBTData = normalizeBTUrls(filteredDataBT);
            
            umc.ping24HoursBT = groupAndSortByUrl(normalizedBTData)
            umc.ping24HoursOrders = groupAndSortByUrl(filteredDataOrders);
            umc.ping24HoursSeatPlans = groupAndSortByUrl(filteredDataSeatPlans);
            umc.ping24Hours = groupAndSortByUrl(filteredDataOther);
            umc.ping24HoursSessionSeatPlans = groupAndSortByUrl(filteredDataSessionSeatPlans);



                    angular.forEach(umc.ping24HoursBT, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
                    angular.forEach(umc.ping24HoursOrders, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
            angular.forEach(umc.ping24HoursSessionSeatPlans, function (value, key) {
                //show last value vesrus average for current ping status and color
                //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
                    angular.forEach(umc.ping24HoursSeatPlans, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });
                    angular.forEach(umc.ping24Hours, function (value, key) {
                        //show last value vesrus average for current ping status and color
                        //value.pingValue = umc.averageNumber(value, 'AverageResponseTimeMs');
                        value.pingValue = value[value.length - 1].AverageResponseTimeMs;
            });

                    // Update loading states
                    umc.isLoading.braintree = false;
                    umc.isLoading.orders = false;
                    umc.isLoading.seatplans = false;
                    umc.isLoading.other = false;
                    umc.isLoading.sessionSeatplans = false;
        } else {
            umc.ping24Hours = null;
            umc.ping24HoursBT = null;
            umc.ping24HoursOrders = null;
            umc.ping24HoursSeatPlans = null;
        }
            $timeout(function () {
                render24HoursCharts();
            }, 1000);
        });
    }

// Around line 394, update the groupAndSortByUrl function to filter Getty in closed months
// Around line 394, update the groupAndSortByUrl function
function groupAndSortByUrl(data) {
    // ❌ REMOVED: Don't filter out Getty - let it show on graphs
    // We only skip Getty errors in the BACKEND (UptimeLogger.cs LogToErrorAlerter)
    
    // First, normalize the data to handle session-based URLs
    const normalizedData = data.map(item => {
        let normalizedUrl = item.EndpointUrl;
        
        // If it's a session seat plan URL, normalize it to group by cinema only
        const sessionMatch = normalizedUrl.match(/RESTData\.svc\/cinemas\/(\d+)\/sessions\/[^\/]+\/seat-plan/i);
        if (sessionMatch) {
            const cinemaId = sessionMatch[1];
            normalizedUrl = `RESTData.svc/cinemas/${cinemaId}/sessions/[session]/seat-plan`;
        }
        
        return {
            ...item,
            NormalizedEndpointUrl: normalizedUrl,
            OriginalEndpointUrl: item.EndpointUrl
        };
    });
    
    // Group by normalized URL instead of actual URL
    let grouped = Object.groupBy(normalizedData, (item) => item.NormalizedEndpointUrl);
    
    // Sort each group by time
    for (const url in grouped) {
        grouped[url].sort((a, b) => jsonDateToJSDate(a.Hour) - jsonDateToJSDate(b.Hour));
    }
    
    return grouped;
}

    // --- Chart Rendering ---
    function render30DaysChart(elementId, daysArray) {
        var ctx = null;
        try {
            ctx = document.getElementById(elementId);
        } catch (err) {
            console.error(elementId, err);
        }
        //const ctx = document.getElementById(elementId);
        const thresholdRed = umc.HEALTH_THRESHOLDS.high;
        const thresholdYellow = umc.HEALTH_THRESHOLDS.medium;
        const labels = daysArray.map(obj => formatDayLabel(obj.date));
        const dayBars = new Array(DAYS).fill(1);

        //old way was checking by average ping, changed to check by HealthyPercentage.
        //const pings = daysArray.map(obj => obj.item.AverageResponseTimeMs ? Math.round(obj.item.AverageResponseTimeMs) : undefined);
        //const backgroundColors = pings.map(function (value) {
        //    if (value == undefined) return 'lightgray';
        //    if (value >= thresholdRed) return 'red';
        //    if (value >= thresholdYellow) return 'yellow';
        //    return 'green';
        //});
        const healthPercentage = daysArray.map(obj => obj.item.HealthyPercentage ? Math.floor(obj.item.HealthyPercentage) : undefined);
        const backgroundColors = healthPercentage.map(function (value) {
            if (value == undefined) return umc.COLORS.none;
            if (value <= thresholdRed) return umc.COLORS.veryBad;   // <= 95%: red (1hr+ of issues)
            if (value <= thresholdYellow) return umc.COLORS.bad;    // <= 98%: yellow (~10-60min of issues)
            if (value < 100) return umc.COLORS.okay;                // 99%: light yellow-green (1-2 failed checks)
            return umc.COLORS.good;                                  // 100%: green (perfect day)
        });

        const data = {
            labels: labels,
            datasets: [{
                label: 'Avg Response Time (ms)',
                data: dayBars,
                backgroundColor: backgroundColors,
                borderColor: backgroundColors
            }]
        };
        const config = {
            type: 'bar',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                var txt = healthPercentage[context.dataIndex] ? healthPercentage[context.dataIndex] + "% uptime" : 'no data';
                                return txt;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: { drawBorder: false, display: false },
                        ticks: { color: 'white', display: false },
                        border: { display: false }
                    },
                    y: {
                        min: 0, max: 1, beginAtZero: true,
                        grid: { drawBorder: false, display: false },
                        ticks: { stepSize: 200, color: 'white', display: false },
                        border: { display: false }
                    }
                },
                layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
                onHover: function (event, elements) {
                    event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
                },
                onClick: function (event, elements) {
                    if (!elements || elements.length === 0) return;
                    var idx = elements[0].index;
                    var clickedDate = daysArray[idx].date;

                    // Set dates and trigger fetch inside Angular digest, then scroll.
                    // Pass the Date object directly — AngularJS input[type="date"] requires
                    // a Date object on the model for the input to visually display the value.
                    $timeout(function () {
                        umc.customStartDate = new Date(clickedDate);
                        umc.customEndDate = new Date(clickedDate);
                        umc.getCustomRangeData();

                        var el = document.querySelector('.custom-range-lookup');
                        if (el) {
                            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    });
                }
            }
        };

    if (CHARTS[elementId]) {
        // Update existing chart
        CHARTS[elementId].data = data;
        CHARTS[elementId].options = config.options;
        CHARTS[elementId].update(); // 'none' for no animation on update
    } else {
        // Create new chart
        CHARTS[elementId] = new Chart(ctx, config);
    }

    }
    // Jump to the Custom Date Range Viewer for a specific day — used by Past Incidents panel
    umc.viewDayInRangeViewer = function (date) {
        $timeout(function () {
            umc.customStartDate = new Date(date);
            umc.customEndDate = new Date(date);
            umc.getCustomRangeData();

            var el = document.querySelector('.custom-range-lookup');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    };

    // Add new function to get custom range data
    umc.getCustomRangeData = function () {
        if (!umc.customStartDate || !umc.customEndDate) return;

        umc.customModalSearching = true;
        umc.customRangeSummary = null;

        var config = {
            params: {
                startDate: new Date(umc.customStartDate).toISOString(),
                endDate: new Date(umc.customEndDate).toISOString(),
                endpointUrl: umc.customEndpoint || null
            }
        };

        $http.get("/rpc/uptime/getResponseTimeByDateRange", config)
            .then(function (response) {
                var sortedData = response.data.sort((a, b) =>
                    jsonDateToJSDate(a.Hour) - jsonDateToJSDate(b.Hour)
                );

                umc.customRangeData = sortedData;

                // Build top offending endpoints summary (only endpoints with issues)
                var grouped = {};
                sortedData.forEach(function (d) {
                    var key = d.EndpointUrl;
                    if (!grouped[key]) {
                        grouped[key] = { endpoint: key, displayName: umc.formatEndpointDisplay(key), totalCount: 0, successCount: 0, worstMs: 0, errors: [], badIntervals: [] };
                    }
                    grouped[key].totalCount += d.TotalCount;
                    grouped[key].successCount += d.SuccessCount;
                    if (d.AverageResponseTimeMs > grouped[key].worstMs) {
                        grouped[key].worstMs = Math.round(d.AverageResponseTimeMs);
                    }
                    if (d.UnhealthyDetails) {
                        d.UnhealthyDetails.split(' | ').forEach(function (msg) {
                            msg = msg.trim();
                            if (msg && grouped[key].errors.indexOf(msg) === -1) {
                                grouped[key].errors.push(msg);
                            }
                        });
                    }
                    // Track bad/veryBad intervals using response time (matches graph point colors)
                    var avgMs = d.AverageResponseTimeMs || 0;
                    var intervalHealthPct = d.TotalCount > 0 ? d.SuccessCount / d.TotalCount * 100 : 100;
                    var intervalSeverity = null;
                    if (avgMs === 0 || avgMs === -1 || intervalHealthPct < 90) {
                        intervalSeverity = 'veryBad';  // failed/unreachable
                    } else if (avgMs > umc.PING_THRESHOLDS.bad) {
                        intervalSeverity = 'veryBad';  // > 3000ms
                    } else if (avgMs > umc.PING_THRESHOLDS.okay) {
                        intervalSeverity = 'bad';       // > 1500ms — gold/yellow
                    }
                    if (intervalSeverity) {
                        grouped[key].badIntervals.push({ time: jsonDateToJSDate(d.Hour), severity: intervalSeverity });
                    }
                });

                // Merge consecutive bad intervals into human-readable time ranges, tracking worst severity
                var severityRank = { bad: 1, veryBad: 2 };
                function mergeIntervals(intervals) {
                    if (!intervals || intervals.length === 0) return [];
                    intervals.sort(function (a, b) { return a.time - b.time; });
                    var ranges = [];
                    var rangeStart    = intervals[0].time;
                    var rangeLast     = intervals[0].time;
                    var worstSeverity = intervals[0].severity;
                    var INTERVAL_MS   = 31 * 60 * 1000;
                    for (var i = 1; i < intervals.length; i++) {
                        if (intervals[i].time - rangeLast <= INTERVAL_MS) {
                            rangeLast = intervals[i].time;
                            if (severityRank[intervals[i].severity] > severityRank[worstSeverity]) {
                                worstSeverity = intervals[i].severity;
                            }
                        } else {
                            ranges.push({ start: rangeStart, end: rangeLast, severity: worstSeverity });
                            rangeStart    = intervals[i].time;
                            rangeLast     = intervals[i].time;
                            worstSeverity = intervals[i].severity;
                        }
                    }
                    ranges.push({ start: rangeStart, end: rangeLast, severity: worstSeverity });
                    return ranges;
                }

                function fmtTime(d) {
                    return $filter('date')(d, 'h:mm a');
                }

                umc.customRangeSummary = Object.values(grouped)
                    .map(function (g) {
                        g.healthPct = g.totalCount > 0 ? Math.floor(g.successCount / g.totalCount * 100) : 100;
                        var ranges = mergeIntervals(g.badIntervals);
                        g.issueRanges = ranges.map(function (r) {
                            return {
                                label: r.start.getTime() === r.end.getTime()
                                    ? fmtTime(r.start)
                                    : fmtTime(r.start) + ' – ' + fmtTime(r.end),
                                severity: r.severity
                            };
                        });
                        return g;
                    })
                    .filter(function (g) { return g.healthPct < 100 || g.errors.length > 0; })
                    .sort(function (a, b) { return a.healthPct - b.healthPct; })
                    .slice(0, 5);

                $timeout(function () {
                    createCustomRangeChart('custom-range-chart',
                        sortedData.map(d => formatCustomRangeTime(jsonDateToJSDate(d.Hour))),
                        sortedData.map(d => Math.round(d.AverageResponseTimeMs))
                    );
                }, 100);
            })
            .finally(function () {
                umc.customModalSearching = false;
            });
    };
    function generate24HourPlaceholder() {
        const data = [];
        const now = new Date();
        for (let i = 23; i >= 0; i--) {
            data.push({
                EndpointUrl: '',
                Hour: new Date(now.getTime() - (i * 3600000)),
                AverageResponseTimeMs: 500 // Default placeholder value
            });
        }
        return data;
    }

    function generatePlaceholderGroup(count) {
        const placeholderGroup = {};
        for (let i = 1; i <= count; i++) {
            placeholderGroup[`placeholder-${i}`] = generate24HourPlaceholder();
        }
        return placeholderGroup;
    }

    // Initialize with placeholder data
    umc.ping24HoursBT = generatePlaceholderGroup(11);
    umc.ping24HoursOrders = generatePlaceholderGroup(11);
    umc.ping24HoursSeatPlans = generatePlaceholderGroup(10);
    umc.ping24Hours = generatePlaceholderGroup(4);
    umc.ping24HoursSessionSeatPlans = generatePlaceholderGroup(10);

    // Add loading states (for 24-hour chart cards)
    umc.isLoading = {
        braintree: true,
        orders: true,
        seatplans: true,
        sessionSeatplans: true,
        other: true
    };

    // Separate loading states for 30-day charts (cleared independently of 24-hour data)
    // These start true on initial load and go false when each 30-day API resolves.
    // Auto-refresh never resets them, so background refreshes are silent.
    umc.isLoading30 = {
        braintree: true,
        nonBraintree: true,
        orders: true,
        seatplans: true,
        sessionSeatplans: true
    };
    // Add helper function for date/time formatting
    function formatCustomRangeTime(dateObject) {
        return $filter('date')(dateObject, 'MMM d, h:mm a');
    }
    // Modified chart creation for custom range
   
    function createCustomRangeChart(elmId, labels, pings) {
        var ctx = document.getElementById(elmId);
        const MAX_DISPLAY_PING = 15000;

        // Store original values for tooltips
        const originalPings = [...pings];

        // Transform pings for display
        const displayPings = pings.map(ping => {
            if (ping === 0 || ping === -1) return MAX_DISPLAY_PING - 1;
            return Math.min(ping, MAX_DISPLAY_PING - 1);
        });

        // Calculate dynamic max
        const maxDisplayValue = Math.max(...displayPings);
        const dynamicMax = Math.min(
            Math.max(3000, Math.ceil(maxDisplayValue / 1000) * 1000),
            MAX_DISPLAY_PING
        );

        const data = {
            labels: labels,
            datasets: [{
                label: 'Response Time (ms)',
                data: displayPings,
                fill: false,
                borderColor: 'rgb(224, 60, 49)',
                tension: 0.1,
                pointRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Make capped values larger and more visible
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 4;
                    }
                    return 0.5;
                },
                pointHoverRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 8;
                    }
                    return 7;
                },
                pointBackgroundColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderWidth: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 2;
                    }
                    return 1;
                },
                segment: {
                    borderColor: function (context) {
                        const originalValue = originalPings[context.p1DataIndex];
                        if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                        if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                        if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                        if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                        return umc.COLORS.veryBad;
                    }
                }
            }]
        };

        const config = {
            type: 'line',
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            label: function (tooltipItem) {
                                const originalValue = originalPings[tooltipItem.dataIndex];

                                if (originalValue === 0 || originalValue === -1) {
                                    return `Server Error @ ${tooltipItem.label}`;
                                }

                                const formattedValue = originalValue.toLocaleString();
                                return `${formattedValue} ms @ ${tooltipItem.label}`;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            maxRotation: 45,
                            minRotation: 45,
                            autoSkip: true,
                            maxTicksLimit: 20
                        }
                    },
                    y: {
                        min: 0,
                        max: dynamicMax,
                        beginAtZero: true,
                        ticks: {
                            stepSize: Math.max(500, Math.floor(dynamicMax / 10)),
                            callback: function (value) {
                                return value.toLocaleString();
                            }
                        }
                    }
                }
            }
        };

        if (CHARTS[elmId]) {
            CHARTS[elmId].destroy();
        }
        CHARTS[elmId] = new Chart(ctx, config);
    }

    function render24HoursCharts() {
        if (!umc.isLoading.braintree) {
            render24HoursChart(umc.ping24HoursBT, umc.btvistacinema, 'btpings-');
        }
        if (!umc.isLoading.orders) {
            render24HoursChart(umc.ping24HoursOrders, umc.btvistacinema, 'orderpings-');
        }
        if (!umc.isLoading.seatplans) {
            render24HoursChart(umc.ping24HoursSeatPlans, umc.btvistacinema, 'seatpings-');
        }
        if (!umc.isLoading.sessionSeatplans) {
            render24HoursChart(umc.ping24HoursSessionSeatPlans, umc.btvistacinema, 'sessionseatpings-');
        }
        if (!umc.isLoading.other) {
            render24HoursChart(umc.ping24Hours, umc.btvistaendpoint, 'btpings-');
        }
    }

    function render24HoursChart(groupedData, endpointLookupFn, chartIdPrefix) {
        if (!groupedData) return;
        for (const key in groupedData) {
            let loc = groupedData[key];
            let locid = endpointLookupFn(loc[0].EndpointUrl).chartid || endpointLookupFn(loc[0].EndpointUrl).id;
            var pings = loc.map(obj => Math.round(obj.AverageResponseTimeMs));
            var hours = loc.map(obj => {
                const dateObject = jsonDateToJSDate(obj.Hour);
                return format24HourTime(dateObject, true);
                //const hours24 = dateObject.getHours();
                //let ampm = hours24 >= 12 ? 'PM' : 'AM';
                //let hours12 = hours24 % 12;
                //hours12 = hours12 ? hours12 : 12;
                //return hours12 + " " + ampm;
            });
            let chartid = chartIdPrefix + locid;
            //console.log('before ping', groupedData);
            createPingChart(chartid, hours, pings, false);
        }
    }

    function createPingChart(elmId, labels, pings, destroy) {
        var ctx = null;
        try {
            ctx = document.getElementById(elmId);
        } catch (err) {
            console.error(elmId, err);
        }

        var thresholdRed = umc.PING_THRESHOLDS.high;
        var thresholdYellow = umc.PING_THRESHOLDS.medium;
        const MAX_DISPLAY_PING = 15000;
        const MAX_DISPLAY_PING_VALUE = 14500;

        // Store original values for tooltips
        const originalPings = [...pings];

        // Transform pings for display: cap at MAX_DISPLAY_PING, treat 0/-1 as errors
        const displayPings = pings.map(ping => {
            if (ping === 0 || ping === -1) return MAX_DISPLAY_PING_VALUE; // Show errors just below max (14999)
            return Math.min(ping, MAX_DISPLAY_PING_VALUE); // Cap outliers at 14999
        });

        // Calculate dynamic max: use the highest display value, rounded up to nearest 1000, but cap at MAX_DISPLAY_PING
        const maxDisplayValue = Math.max(...displayPings);
        const dynamicMax = Math.min(
            Math.max(3000, Math.ceil(maxDisplayValue / 1000) * 1000), // At least 3000, round up to nearest 1000
            MAX_DISPLAY_PING
        );

        const data = {
            labels: labels,
            datasets: [{
                label: 'response time (ms) ',
                data: displayPings,
                fill: false,
                borderColor: 'rgb(224, 60, 49)',
                tension: 0.1,
                pointRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Make capped values larger and more visible
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 4; // Larger dot for capped/error values
                    }
                    return 0.5; // Normal size
                },
                pointHoverRadius: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Larger hover radius for capped values
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 8;
                    }
                    return 7;
                },
                pointBackgroundColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Server errors
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    // Normal thresholds
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderColor: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Server errors
                    if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                    // Normal thresholds
                    if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                    if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                    if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                    return umc.COLORS.veryBad;
                },
                pointBorderWidth: function (context) {
                    const originalValue = originalPings[context.dataIndex];
                    // Thicker border for capped values
                    if (originalValue === 0 || originalValue === -1 || originalValue >= MAX_DISPLAY_PING) {
                        return 2;
                    }
                    return 1;
                },
                segment: {
                    borderColor: function (context) {
                        const originalValue = originalPings[context.p1DataIndex];
                        // Server errors
                        if (originalValue === 0 || originalValue === -1) return umc.COLORS.veryBad;
                        // Normal thresholds
                        if (originalValue <= umc.PING_THRESHOLDS.good) return umc.COLORS.good;
                        if (originalValue <= umc.PING_THRESHOLDS.okay) return umc.COLORS.okay;
                        if (originalValue <= umc.PING_THRESHOLDS.bad) return umc.COLORS.bad;
                        return umc.COLORS.veryBad;
                    }
                }
            }]
        };

        const config = {
            type: 'line',
            data: data,
            stepped: true,
            options: {
                elements: { point: { radius: 1 } },
                responsive: true,
                plugins: {
                    title: { display: false, text: '' },
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        displayColors: false,
                        callbacks: {
                            title: function (context) { return ''; },
                            label: function (tooltipItem) {
                                const originalValue = originalPings[tooltipItem.dataIndex];

                                // Check for server errors
                                if (originalValue === 0 || originalValue === -1) {
                                    return `Server Error @ ${tooltipItem.label}`;
                                }

                                // Show actual value even if capped on display
                                const formattedValue = originalValue.toLocaleString();
                                return `${formattedValue} ms @ ${tooltipItem.label}`;
                            }
                        }
                    },
                    hover: {
                        mode: 'index',
                        intersect: false
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            font: { size: 8 },
                            color: 'white',
                            autoSkip: false,
                            callback: function (val, index, ticks) {
                                var ogLabel = this.getLabelForValue(val);
                                var ogLabels = ogLabel.split(' ').slice(1);
                                ogLabel = ogLabels.join(" ");
                                return (index === ticks.length - 1 || index % 4 === 0) ? ogLabel : '';
                            }
                        },
                    },
                    y: {
                        min: 0,
                        max: dynamicMax,
                        beginAtZero: true,
                        grid: { display: false },
                        ticks: {
                            stepSize: Math.max(500, Math.floor(dynamicMax / 10)),
                            color: 'white',
                            font: { size: 10 },
                            callback: function (value) {
                                return value.toLocaleString();
                            }
                        }
                    }
                }
            }
        };

        if (CHARTS[elmId]) {
            if (destroy) {
                CHARTS[elmId].destroy();
                CHARTS[elmId] = new Chart(ctx, config);
            } else {
                CHARTS[elmId].data = data;
                CHARTS[elmId].options = config.options;
                CHARTS[elmId].update('none');
            }
        } else {
            CHARTS[elmId] = new Chart(ctx, config);
        }
    }

    // --- Utility Functions ---
    umc.averageNumber = function (array, propertyname) {
        let numbers = array.map(obj => obj[propertyname]);
        if (numbers.length === 0) return 0;
        const sum = numbers.reduce((acc, val) => acc + val, 0);
        return Math.round(sum / numbers.length);
    };
    umc.getPingColor = function (pingValue) {
        // Handle error values first
        if (pingValue === 0 || pingValue === -1) {
            return 'veryBad';
        }

        if (pingValue <= umc.PING_THRESHOLDS.good) {
            return 'good';
        } else if (pingValue <= umc.PING_THRESHOLDS.okay) {
            return 'okay';
        } else if (pingValue <= umc.PING_THRESHOLDS.bad) {
            return 'bad';
        } else {
            return 'veryBad';
        }
    }   
    //umc.getDayColor = function (percentages) {
    //    const smallestPercentage = Math.min(...percentages);
    //    var colorClass = 'low';
    //    if (smallestPercentage >= umc.HEALTH_THRESHOLDS.low) {
    //        return 'low';
    //    } else if (smallestPercentage >= umc.HEALTH_THRESHOLDS.medium) {
    //        return 'medium';
    //    } else {
    //        return 'high';
    //    }
    //}
    umc.getDayColor = function (percentages) {
        const smallestPercentage = Math.round(Math.min(...percentages));

        if (smallestPercentage <= umc.HEALTH_THRESHOLDS.high) {      // <= 90
            return 'veryBad';   // Changed from 'high'
        } else if (smallestPercentage <= umc.HEALTH_THRESHOLDS.medium) { // <= 95
            return 'bad';       // Changed from 'medium'
        } else if (smallestPercentage <= umc.HEALTH_THRESHOLDS.low) {   // <= 99
            return 'okay';      // New middle tier
        } else {
            return 'good';      // Changed from 'low'
        }
    }
    function simpleStringHash(str) {
  let hash = 0;
  if (str.length === 0) return hash;

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char; // A common pattern for mixing bits
    hash = hash & hash; // Converts to 32-bit integer
  }
  return hash;
}
function format24HourTime(dateObject, includeDay) {
        const day = dateObject.getDate();

        const ordinal = day + (
            day % 10 == 1 && day != 11 ? 'st' :
            day % 10 == 2 && day != 12 ? 'nd' :
            day % 10 == 3 && day != 13 ? 'rd' : 'th'
        );
        
        const hours24 = dateObject.getHours();
        let ampm = hours24 >= 12 ? 'PM' : 'AM';
        let hours12 = hours24 % 12;
        hours12 = hours12 ? hours12 : 12;

        if (includeDay) {
            return ordinal + ' ' + hours12 + " " + ampm;
        } else {
            return hours12 + " " + ampm;
        }
    }

    //umc.getCustomResponseTime = function () {
    //    umc.customModalSearching = true;
    //    if (!umc.selectedDate || !umc.selectedEndpoint) return;
    //    let fixedDate = umc.selectedDate + "T00:00:00";
    //    getResponseTimeByDateAndEndpoint(new Date(fixedDate), umc.selectedEndpoint)
    //        .then(function (response) {    

    //            var sortedData = response.data.sort((a, b) => 
    //                jsonDateToJSDate(a.Hour) - jsonDateToJSDate(b.Hour)
    //            );

    //            umc.customSearchResults = sortedData;

    //            //$('#custom-ping-modal').modal({ show: true, backdrop: 'static', keyboard: false });

    //            // Wait for DOM to be ready
    //            $timeout(function () {
    //                createPingChart('custom-search-chart',
    //                    sortedData.map(d => format24HourTime(jsonDateToJSDate(d.Hour), true)), // Format hours
    //                    sortedData.map(d => Math.round(d.AverageResponseTimeMs)),      // Get response times
    //                    true //destroy chart
    //                );
    //            }, 100);
    //        })
    //        .finally(function(response) {umc.customModalSearching = false;});
    //};

    // --- API Wrappers for Angular ---
    umc.getBraintreeDailyHealthLast30Days = getBraintreeDailyHealthLast30Days;
    umc.getNonBraintreeDailyHealthLast30Days = getNonBraintreeDailyHealthLast30Days;
    umc.getOrdersDailyHealthLast30Days = getOrdersDailyHealthLast30Days;
    umc.getSeatPlansDailyHealthLast30Days = getSeatPlansDailyHealthLast30Days;
    umc.getSessionSeatPlansDailyHealthLast30Days = getSessionSeatPlansDailyHealthLast30Days;
    umc.get24HourPings = get24HourPings;

    // --- Lookup Data ---
    //umc.VISTA_ENDPOINTS_KEY = [
    //    { "name": "Login", "endpoint": "RESTLoyalty.svc/member/validate", "chartid": "login" },
    //    { "name": "Gift Cards", "endpoint": "RESTData.svc/gift-cards/balance/90010069597767027132", "chartid": "giftcard" },
    //    { "name": "Cinemas", "endpoint": "OData.svc/Cinemas", "chartid": "cinemas" },
    //    { "name": "MFO Toggle", "endpoint": "https://api.celemonitor.com/api/mfoStatus", "chartid": "mfotoggle" }
    //];
    umc.CINEMA_KEY = [
        { "id": "001", "name": "", "enabled": false },
        {
            "id": "009",
            "name": "Carousel",
            "enabled": true,
            "server": "AR-DB01",
            "description": "Cinema Carousel - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "007",
            "name": "Benton",
            "enabled": true,
            "server": "BH-DB01",
            "description": "Celebration Benton Harbor - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "003",
            "name": "Crossroads",
            "enabled": true,
            "server": "CR-DB01",
            "description": "Celebration Crossroads - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "011",
            "name": "Getty",
            "enabled": true,
            "server": "GD-DB01",
            "description": "Getty Drive-in - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "002",
            "name": "GR North",
            "enabled": true,
            "server": "GN-DB01",
            "description": "Celebration GR North - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "004",
            "name": "GR South",
            "enabled": true,
            "server": "GS-DB01",
            "description": "Celebration GR South - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "006",
            "name": "Lansing",
            "enabled": true,
            "server": "LA-DB01",
            "description": "Celebration Lansing - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "008",
            "name": "Mt Pleasant",
            "enabled": true,
            "server": "MP-DB01",
            "description": "Celebration Mt Pleasant - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "012",
            "name": "Meridian Mall",
            "enabled": true,
            "server": "MM-DB01",
            "description": "Studio C Meridian Mall - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "005",
            "name": "Rivertown",
            "enabled": true,
            "server": "RT-DB01",
            "description": "Celebration Rivertown - Handles Bookings / serves up seat map / concession orders"
        },
        {
            "id": "013",
            "name": "Studio Park/MT",
            "enabled": true,
            "server": "SP-DB01",
            "description": "Celebration Studio Park - Handles Bookings / serves up seat map / concession orders"
        },
        { "id": "010", "name": "", "enabled": false },
        {
            "id": "999",
            "name": "Gift Store",
            "enabled": true,
            "server": "CO-GS01",
            "description": "Gift Store Server"
        }
    ];

    // --- Lookup Functions ---
    umc.btvistaendpoint = function (endpointUrl) {
        //const found = umc.VISTA_ENDPOINTS_KEY.find(item => endpointUrl === String(item.endpoint));
        const found = umc.VISTA_ENDPOINTS_KEY.find(item => endpointUrl.includes(String(item.endpoint)));
        return found || '';
    };
umc.formatEndpointDisplay = function (endpointUrl) {
    if (!endpointUrl) return endpointUrl;
    var cinema = umc.btvistacinema(endpointUrl);
    var cinemaName = cinema && cinema.name ? cinema.name : endpointUrl;

    if (endpointUrl.includes('/sessions/') && endpointUrl.includes('seat-plan')) {
        return 'Session Seat Plans / ' + cinemaName;
    }
    if (endpointUrl.includes('/screens/') && endpointUrl.includes('seat-plan')) {
        return 'Seat Plans / ' + cinemaName;
    }
    if (endpointUrl.includes('payment-access-tokens/Braintree')) {
        return 'Braintree / ' + cinemaName;
    }
    if (endpointUrl.includes('orders?cinemaId')) {
        return 'Orders / ' + cinemaName;
    }
    // Fall back to the endpoint name lookup for central services
    var ep = umc.btvistaendpoint(endpointUrl);
    return ep && ep.name ? ep.name : endpointUrl;
};

umc.findMatchingDropdownKey = function (endpointUrl) {
    if (!endpointUrl) return endpointUrl;
    // Exact match across all ping groups
    var groups = [umc.ping24Hours, umc.ping24HoursBT, umc.ping24HoursOrders,
                  umc.ping24HoursSeatPlans, umc.ping24HoursSessionSeatPlans];
    for (var i = 0; i < groups.length; i++) {
        if (groups[i] && groups[i][endpointUrl] !== undefined) return endpointUrl;
    }
    // Session seat plans: session IDs change daily — match same cinema ID only
    if (endpointUrl.includes('/sessions/') && endpointUrl.includes('seat-plan') && umc.ping24HoursSessionSeatPlans) {
        var cinemaMatch = endpointUrl.match(/cinemas\/(\d+)\//i);
        if (cinemaMatch) {
            var cinemaId = cinemaMatch[1];
            var keys = Object.keys(umc.ping24HoursSessionSeatPlans);
            for (var j = 0; j < keys.length; j++) {
                if (keys[j].toLowerCase().includes('/cinemas/' + cinemaId + '/')) return keys[j];
            }
        }
    }
    return endpointUrl;
};

umc.viewEndpointInRange = function (endpointUrl) {
    umc.customEndpoint = umc.findMatchingDropdownKey(endpointUrl);
    umc.getCustomRangeData();
    var el = document.querySelector('.custom-range-lookup');
    if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
};

umc.btvistacinema = function (endpointUrl) {
    // Handle normalized session URLs
    const sessionMatch = endpointUrl.match(/cinemas\/(\d+)\/sessions/i);
    if (sessionMatch) {
        const cinemaId = sessionMatch[1];
        const found = umc.CINEMA_KEY.find(item => item.id === cinemaId);
        return found || '';
    }
    
    // Original logic for other URLs
    const found = umc.CINEMA_KEY.find(item => endpointUrl.includes(String(item.id)));
    return found || '';
};
}